import {fetchRetry} from "./network";
import * as Sentry from "@sentry/browser";
import {measureTime} from "./debug";

async function getLocationByIp() {
    let response = await fetchRetry("https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyB_q1onZH2olCGlLDWKAOhPCw1LLcOmh60", {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        timeout: 5000
    }, 2);
    if (response === undefined) {
        Sentry.captureMessage("Location Fallback", "warning");
    } else {
        let json_res = await response.json();
        return {"coords": {"latitude": json_res["location"]["lat"], "longitude": json_res["location"]["lng"]}}
    }
}

export function getLocationFromStorage() {
    console.log("getLocationFromStorage");
    const urlParams = new URLSearchParams(window.location.search);
    let lat = urlParams.get('lat');
    let lon = urlParams.get('lon');
    // if lat and lon specified, we always want them
    if (lat != null && lon != null) {
        return {coords: {latitude: lat, longitude: lon}};
    }
    const storedLocation = localStorage.getItem('location');
    if (storedLocation) {
        return JSON.parse(storedLocation);
    }
    return null;
}

function setLocationToStorage(position) {
    localStorage.setItem('location', JSON.stringify(
        {
            "coords": {
                "latitude": position.coords.latitude,
                "longitude": position.coords.longitude
            }
        }));
}

export async function getLocation() {
    console.log("getLocation");
    let position = getLocationFromStorage();
    if (!position) {
        position = await measureTime(getLocationByIp)();
        setLocationToStorage(position);
    }
    return position;
}